import { Box, Heading, Text } from '@razorpay/blade/components';
import React from 'react';
import { GetWorkflowRequestDetailsContract } from 'schemas/GetWorkflowRequestDetails';
import { transformFinalizePayrollRequestData } from '../FinalizePayroll/utils';
import { format } from 'date-fns';
import { DetailsSkeleton } from 'components/ui/Skeletons/DetailsSkeleton';

export interface FinalizePayrollDetailsProps {
  workflowRequestDetails?: GetWorkflowRequestDetailsContract;
  isLoading?: boolean;
}

const FinalizePayrollDetails = ({
  workflowRequestDetails,
  isLoading,
}: FinalizePayrollDetailsProps) => {
  if (isLoading || !workflowRequestDetails) {
    return <DetailsSkeleton rowCount={4} />;
  }

  const requestData = transformFinalizePayrollRequestData(
    workflowRequestDetails.workflow_requests_data,
  );

  const details = [
    {
      label: 'Payroll Month',
      content: (
        <Text color="surface.text.gray.subtle">{format(new Date(requestData.payrollMonth as string), 'MMMM')}</Text>
      ),
    },
    {
      label: 'Finalized Employees',
      content: <Text color="surface.text.gray.subtle">{requestData.finalizedEmployees}</Text>,
    },
    {
      label: 'Skipped Employees',
      content: <Text color="surface.text.gray.subtle">{requestData.skippedEmployees}</Text>,
    },
  ];

  return (
    (<Box display="flex" flexDirection="column" gap="spacing.5">
      <Box display="flex" gap="spacing.2" alignItems="baseline">
        <Heading weight="semibold" size="medium" color="surface.text.gray.normal">
          Finalize Payroll
        </Heading>
        <Heading weight="regular" size="medium" color="surface.text.gray.normal">
          Details
        </Heading>
      </Box>
      <Box display="flex" flexDirection="column" gap="spacing.5">
        {details.map(({ label, content }, index) => (
          <Box display="flex" gap="spacing.5" alignItems="baseline" key={index}>
            <Box width="120px">
              <Text color="surface.text.gray.subtle">{label}</Text>
            </Box>
            <Box>{content}</Box>
          </Box>
        ))}
      </Box>
    </Box>)
  );
};

export { FinalizePayrollDetails };
